import styled from "styled-components";
import { StyledProps } from "src/ts-types";
import * as colors from "src/styles/constants/colors";
import * as spacing from "src/styles/constants/spacing";
import * as radius from "src/styles/constants/radius";
import * as typography from "src/styles/constants/typography";

type TextFieldProps = {
  disabled?: boolean;
  modified?: boolean;
} & StyledProps;

export const Field = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  height: ${spacing.space_xl};
  margin-bottom: ${spacing.space_m};
  padding: ${spacing.space_s};
  border: 1px solid ${colors.active};
  border-radius: ${radius.small};
`;

export const TextField = styled(Field)<TextFieldProps>`
  height: initial;
  min-height: ${spacing.space_xl};
  flex-direction: column;
  align-items: flex-end;
  border: 1px solid
    ${(props) => (props.modified ? `${colors.orange500}` : `${colors.active}`)};
  textarea {
    resize: none !important;
    width: 100%;
    line-height: 24px;
    border: 0;
    padding: 0 ${spacing.space_s};
    font-weight: ${typography.semiBold};
    font-size: 0.88rem;
    :disabled {
      cursor: not-allowed;
    }
  }
`;
